import axios from 'axios';
import { BRAND_BASE_URL, CONSUMER_BASE_URL, STORE_BASE_URL } from '../BaseURL';
import getHeaders from '../../constants/headers';

export const PostLoyaltyPoint = (brandId, data) => {
  return axios({
    method: 'post',
    url:
      CONSUMER_BASE_URL +
      '/api/secure/v1/brand/' +
      brandId +
      '/loyalty-point-config', // for android use
    headers: getHeaders(),
    data: JSON.stringify(data),
  });
};


export const PutLoyaltyPoint = (brandId, data) => {
  return axios({
    method: 'put',
    url:
      CONSUMER_BASE_URL +
      '/api/secure/v1/brand/' +
      brandId +
      '/loyalty-point-config', // for android use
    headers: getHeaders(),
    data: JSON.stringify(data),
  });
}


export const getLoyaltyPoint = brandId => {
  return axios({
    method: 'get',
    url: CONSUMER_BASE_URL + '/api/secure/v1/brand/' + brandId + '/loyalty-point-config', // for android use
    headers: getHeaders(),
  });
};


export const getCustomerLoyaltyPointLog = data => {
  return axios({
    method: 'post',
    url: CONSUMER_BASE_URL + '/api/secure/v1/loyalty-point-log',
    headers: getHeaders(),
    data: JSON.stringify(data),
  });
};


// add this in log for discount value if --data '{
    // "verificationRequested" : false
// }'


// add this in delivery
// verificationRequested: true "orderAmount" : 100,


export const getCustomerLoyaltyPointCheckDiscount = (storeId, storeCustomerId,data) => {
  return axios({
    method: 'post',
    url: CONSUMER_BASE_URL + '/api/secure/v1/store/' + storeId + '/store-customer/' + storeCustomerId  + '/loyalty-point/check-discount',
    headers: getHeaders(),
    data: JSON.stringify(data),
  });
};


// -data '{
    // "verificationRequested" : true,
    // "orderAmount" :200,
    // "verificationCode" :"123098"
// }'


// apply to convert points to discount amount in delivery


export const getCustomerLoyaltyPointApplyDiscount = (
  storeId,
  storeCustomerId,
  data,
) => {
  return axios({
    method: 'post',
    url:
      CONSUMER_BASE_URL +
      '/api/secure/v1/store/' +
      storeId +
      '/store-customer/' +
      storeCustomerId +
      '/loyalty-point/apply-discount',
    headers: getHeaders(),
    data: JSON.stringify(data),
  });
};


export const getOrderSubscriptionInfo = (storeId, storeCustomerId, orderId)  => {
  return axios({
    method: 'get',
    url: STORE_BASE_URL + '/store/api/secure/v1/store/' + storeId + '/store-customer/' + storeCustomerId + '/order/' + orderId + '/subscription-info', // for android use
    headers: getHeaders(),
  });
};

export const postStoreCustomerLoyaltyPoints = async (data) => {
  return axios({
    method: "post",
    url: BRAND_BASE_URL + "/consumer/api/secure/v1/store-customer-loyalty-point",
    headers: getHeaders(),
    data: JSON.stringify(data),
  });
};
